import React from 'react';
import { observer } from 'mobx-react';
import { getSnapshot } from 'mobx-state-tree';
import { useEffect, useState } from 'react';
import NewAssessmentDetails from '../components/PerformanceReviews/NewAssessmentDetails';
import { Input, Grid, Icon } from 'semantic-ui-react';
import { AssessmentUserViewModel } from '../models/AssessmentUserViewModel';
import {
    TableRow,
    TableHeaderCell,
    TableHeader,
    TableCell,
    TableBody,
    Table,
    Card,
    CardContent,
    CardHeader,
} from 'semantic-ui-react';

const NewAssessmentsReportPage = ({ usersStore, assessmentsStore, companyStore }) => {
    const [managersMap, setManagersMap] = useState({});
    const [salesPersonFilter, setSalesPersonFilter] = useState('');
    const [managerFilter, setManagerFilter] = useState('');
    const [list, setList] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState(null);

    useEffect(() => {
        let map = usersStore.salesManagers.reduce((acc, curr) => {
            acc[curr.userId] = curr;
            return acc;
        }, {});

        setManagersMap(map);

    }, [usersStore.salesManagers]);

    useEffect(() => {
        const currentUser = usersStore.currentUser;
        let workingList = currentUser.isExecutive ? usersStore.companyUsers : 
                         (currentUser.userType === 'Senior Manager') ? usersStore.getSeniorManagerVisibleUsers(currentUser.userId) :
                         usersStore.getDirectReports(currentUser.userId);

        if (salesPersonFilter) {
            workingList = workingList.filter(user => user.fullName.toLowerCase().indexOf(salesPersonFilter.toLowerCase()) > -1);
        }
        workingList = workingList.map(user => AssessmentUserViewModel.create({ ...getSnapshot(user), reportsToName: managersMap[user.reportsToId]?.fullName ?? '' }));

        if (managerFilter) {
            workingList = workingList.filter(user => user.reportsToName.toLowerCase().indexOf(managerFilter.toLowerCase()) > -1);
        }

        setList(workingList);
    }, [managersMap, salesPersonFilter, usersStore.companyUsers, managerFilter, usersStore]);

    return <div>
        <h1 style={{ fontFamily: 'Inter, system-ui, sans-serif', fontSize: '1.5rem', fontWeight: 700, color: '#1a1a2e', margin: '0 0 16px 0' }}>Performance Reports</h1>
        <Grid columns={2} stretched>
            <Grid.Row>
                <Grid.Column>
                    <Input
                        fluid
                        icon={<Icon name='search' />}
                        placeholder='Search Salesperson...'
                        onChange={(e) => setSalesPersonFilter(e.target.value)}
                    />
                </Grid.Column>
                <Grid.Column>
                    <Input
                        fluid
                        icon={<Icon name='search' />}
                        placeholder='Search Manager...'
                        onChange={(e) => setManagerFilter(e.target.value)}
                    />
                </Grid.Column>
            </Grid.Row>
        </Grid>
        <Card fluid>
            <CardContent>
                <CardHeader>Assessments</CardHeader>
            </CardContent>
            <CardContent style={{ padding: 0 }}>
                <Table style={{ border: 'none' }}>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell>Salesperson</TableHeaderCell>
                            <TableHeaderCell>Role</TableHeaderCell>
                            <TableHeaderCell>Latest Assessment</TableHeaderCell>
                            <TableHeaderCell>Latest Grade</TableHeaderCell>
                            <TableHeaderCell>Reports To</TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {list.map((user) => {
                            const assessments = assessmentsStore.assessmentsGroupedById[user.userId] ?? [];
                            const latestAssessment = assessments.length > 0 ? assessments[0] : undefined;
                            return (
                                <React.Fragment key={user.userId}>
                                    <Table.Row
                                        onClick={() => setSelectedUserId(selectedUserId === user.userId ? null : user.userId)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <TableCell>{user.fullName}</TableCell>
                                        <TableCell>{user.userType}</TableCell>
                                        <TableCell>{latestAssessment?.completedDateTime ? new Date(latestAssessment.completedDateTime).toLocaleDateString() : ''}</TableCell>
                                        <TableCell>
                                            <div
                                                data-testid='rating'
                                                style={{
                                                    width: 16,
                                                    height: 16,
                                                    borderRadius: '50%',
                                                    backgroundColor: { green: '#21ba45', yellow: '#fbbd08', red: '#db2828', grey: '#767676' }[latestAssessment?.grade] || '#767676',
                                                    marginLeft: '19px',
                                                    display: 'inline-block',
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell>{user.reportsToName}</TableCell>
                                    </Table.Row>
                                    {selectedUserId === user.userId && (
                                        <Table.Row>
                                            <Table.Cell colSpan="5" style={{ padding: 0 }}>
                                                <NewAssessmentDetails
                                                    assessments={assessments}
                                                />
                                            </Table.Cell>
                                        </Table.Row>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    </div>;


};

export default observer(NewAssessmentsReportPage);